"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelResultPredictionExamination = void 0;
var widgets_datagrid_1 = require("@tableau/widgets-datagrid");
var React = require("react");
var react_redux_1 = require("react-redux");
var Localize_1 = require("../../../../gen-src/Localize");
var RootReducer_1 = require("../../../app/RootReducer");
var ModelResultSlice_1 = require("../../../store/slice/ModelResultSlice");
var ModelResultStyles_1 = require("../../../styles/ModelResultStyles");
var styles = require("../../../styles/ModelResultStyles");
var NumberUtils_1 = require("../../../util/NumberUtils");
var Utils_1 = require("../../../util/Utils");
var SortableDataGrid_1 = require("../../base/SortableDataGrid");
var Analyses_1 = require("../type/Analyses");
var getFractionDigits = function (num) {
    return num > 1 ? 2 : 4;
};
var ModelResultPredictionExamination = function () {
    var _a = (0, RootReducer_1.useAppSelector)(function (root) { return root.modelResult; }), threshold = _a.sessionThreshold, modelMetrics = _a.modelMetrics, type = _a.type, modelFields = _a.modelFields, predictions = _a.predictions, waveQuery = _a.waveQuery, modelOutcome = _a.modelOutcome;
    var dispatch = (0, react_redux_1.useDispatch)();
    if (!modelMetrics || !type || !modelFields || !predictions || !waveQuery || !modelOutcome) {
        return null;
    }
    var isBinomial = (0, Utils_1.isBinomialModel)(type);
    var buildDataGridColumns = function () {
        var commonColumn = [
            {
                name: 'predicted',
                dataKey: 'predicted',
                headerText: Localize_1.Messages.modelResultsPredictionExaminationPredicted(),
                sortable: true,
                resizable: true,
            },
            {
                name: 'actual',
                dataKey: 'actual',
                headerText: Localize_1.Messages.modelResultsPredictionExaminationActual(),
                sortable: true,
                resizable: true,
            },
        ];
        var cols = isBinomial
            ? __spreadArray(__spreadArray([], commonColumn, true), [
                {
                    name: 'comparison',
                    dataKey: 'comparison',
                    headerText: Localize_1.Messages.modelResultsPredictionExaminationPredictedEqualActual(),
                    sortable: true,
                    resizable: true,
                },
                {
                    name: 'score',
                    dataKey: 'score',
                    headerText: Localize_1.Messages.modelResultsPredictionExaminationScore(),
                    sortable: true,
                    resizable: true,
                },
            ], false) : __spreadArray(__spreadArray([], commonColumn, true), [
            {
                name: 'residual',
                dataKey: 'residual',
                headerText: Localize_1.Messages.modelResultsPredictionExaminationResidual(),
                sortable: true,
                resizable: true,
            },
            {
                name: 'percent',
                dataKey: 'percent',
                headerText: Localize_1.Messages.modelResultsPredictionExaminationPercent(),
                sortable: true,
                resizable: true,
            },
        ], false);
        modelFields.forEach(function (field) {
            if (!field.ignored && !field.protected) {
                var col = {
                    name: field.name,
                    dataKey: field.name,
                    headerText: field.displayName,
                    sortabel: true,
                    resizable: true,
                };
                cols.push(col);
            }
        });
        return cols;
    };
    var buildDataGridRows = function () {
        var rows = waveQuery.records.map(function (row, index) {
            var _a;
            var prediction = predictions[index].prediction;
            var predicted = 0;
            var newRow;
            if (prediction.total) {
                predicted = prediction.total;
                if (isBinomial && threshold !== null) {
                    var success = void 0;
                    var failure = void 0;
                    if (modelOutcome.type === Analyses_1.OutcomeType.Text) {
                        success = modelOutcome.successValue;
                        failure = modelOutcome.failureValue;
                    }
                    else {
                        success = 1;
                        failure = 0;
                    }
                    predicted = prediction.total / 100 >= threshold ? success : failure;
                }
            }
            var actual = row[modelOutcome.name];
            if (!isBinomial) {
                var predictedNumber = predicted;
                var residual = predictedNumber - actual;
                var percent = (predictedNumber * 100) / actual;
                newRow = {
                    key: index.toString(),
                    data: __assign(__assign({}, row), { middleValues: prediction.middleValues, predicted: (0, NumberUtils_1.formatNumericField)({ value: predictedNumber, fractionDigits: getFractionDigits(predictedNumber) }), actual: (0, NumberUtils_1.formatNumericField)({ value: actual, fractionDigits: getFractionDigits(actual) }), residual: (0, NumberUtils_1.formatNumericField)({ value: residual, fractionDigits: getFractionDigits(residual) }), percent: (0, NumberUtils_1.formatNumericField)({ value: percent, fractionDigits: getFractionDigits(percent) }) }),
                };
            }
            else {
                var total = (_a = predictions[index].prediction.total) !== null && _a !== void 0 ? _a : 0;
                newRow = {
                    key: index.toString(),
                    data: __assign(__assign({}, row), { middleValues: prediction.middleValues, predicted: predicted, actual: actual, comparison: predicted === actual ? (React.createElement("span", { className: styles.DataGridPredictedValueSuccess }, "True")) : (React.createElement("span", { className: styles.DataGridPredictedValueFailure }, "False")), score: total ? (0, NumberUtils_1.formatNumericField)({ value: total / 100, fractionDigits: getFractionDigits(total / 100) }) : '' }),
                };
            }
            return newRow;
        });
        return rows;
    };
    var dataGridRows = buildDataGridRows();
    var getDataGridColumnType = function (columnName) {
        if (isBinomial) {
            if (columnName === 'predicted' || columnName === 'actual' || columnName === 'comparison') {
                return Analyses_1.FieldColumnType.Text;
            }
            else if (columnName === 'score') {
                return Analyses_1.FieldColumnType.Number;
            }
        }
        else {
            if (columnName === 'predicted' || columnName === 'actual' || columnName === 'residual' || columnName === 'percent') {
                return Analyses_1.FieldColumnType.Number;
            }
        }
        var column = modelFields.filter(function (field) { return field.name === columnName; });
        if (column.length > 0) {
            return column[0].type;
        }
        return Analyses_1.FieldColumnType.Text;
    };
    // Special sorter for html element sort
    var getHtmlTextForSorter = function (row, sortKey) {
        var _a, _b, _c;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return (_c = (_b = (_a = row.data[sortKey]) === null || _a === void 0 ? void 0 : _a.props) === null || _b === void 0 ? void 0 : _b.children) !== null && _c !== void 0 ? _c : '';
    };
    var dataGridRowSorter = function (rows, sortKey, sortAscending) {
        var columnType = getDataGridColumnType(sortKey);
        if (columnType === Analyses_1.FieldColumnType.Text) {
            rows.sort(function (a, b) {
                if (typeof a.data[sortKey] === 'string' && typeof b.data[sortKey] === 'string') {
                    var aValue = a.data[sortKey];
                    var bValue = b.data[sortKey];
                    return sortAscending ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
                }
                else if (typeof a.data[sortKey] === 'object' && typeof b.data[sortKey] === 'object') {
                    var aValue = getHtmlTextForSorter(a, sortKey);
                    var bValue = getHtmlTextForSorter(b, sortKey);
                    return sortAscending ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
                }
                return 0;
            });
        }
        else if (columnType === Analyses_1.FieldColumnType.Number) {
            rows.sort(function (a, b) {
                var aValue = a.data[sortKey] instanceof Number ? a.data[sortKey] : parseFloat(a.data[sortKey]);
                var bValue = b.data[sortKey] instanceof Number ? b.data[sortKey] : parseFloat(b.data[sortKey]);
                return sortAscending ? bValue - aValue : aValue - bValue;
            });
        }
        else if (columnType === Analyses_1.FieldColumnType.Date) {
            rows.sort(function (a, b) {
                var aValue = new Date(a.data[sortKey]);
                var bValue = new Date(b.data[sortKey]);
                return sortAscending ? bValue.getTime() - aValue.getTime() : aValue.getTime() - bValue.getTime();
            });
        }
        return rows;
    };
    var dataGridSelection = function (selectedRowKey) {
        var index = parseInt(selectedRowKey, 10);
        var selectedRow = isBinomial
            ? {
                metadata: {
                    predicted: dataGridRows[index].data.predicted,
                    actual: dataGridRows[index].data.actual,
                    score: dataGridRows[index].data.score,
                },
                topFactors: dataGridRows[index].data.middleValues,
            }
            : {
                metadata: {
                    predicted: dataGridRows[index].data.predicted,
                    actual: dataGridRows[index].data.actual,
                    residual: dataGridRows[index].data.residual,
                    percent: dataGridRows[index].data.percent,
                },
                topFactors: dataGridRows[index].data.middleValues,
            };
        dispatch((0, ModelResultSlice_1.setSelectedPrediction)(selectedRow));
    };
    var sortedDataGridProps = {
        dataGridProps: {
            cols: buildDataGridColumns(),
            rowStore: new widgets_datagrid_1.ArrayRowStore(dataGridRows),
            showHeaders: true,
            showHorizontalGridLines: true,
            showRowBanding: false,
        },
        dataGridRowSorter: dataGridRowSorter,
        dataGridSelection: dataGridSelection,
    };
    return (React.createElement("div", { className: ModelResultStyles_1.DataGridContainer },
        React.createElement(SortableDataGrid_1.SortableDataGrid, __assign({}, sortedDataGridProps))));
};
exports.ModelResultPredictionExamination = ModelResultPredictionExamination;
//# sourceMappingURL=ModelResultPredictionExamination.js.map